import React, { useEffect, useState } from 'react';
import { Stack, TextField } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import { useAppDispatch } from '../../../../../app/hooks';
import { useUpsertRuleMutation, useDeleteRuleMutation, contractApi } from '../../../../../services/ContractService';
import { RuleCommands } from './RuleCommands';

interface DrgConversionsProps {
  ruleId: string;
  ruleString?: string;
  ruleDescription?: string;
}

const DrgConversions: React.FC<DrgConversionsProps> = ({ ruleId, ruleString = '', ruleDescription = '' }) => {
  const [searchParams] = useSearchParams();
  const contractId = searchParams.get('id');
  const dispatch = useAppDispatch();
  const [rule, setRule] = useState({ drg: '', description: '', rate: 0 });
  const [upsertRule] = useUpsertRuleMutation();
  const [deleteRule] = useDeleteRuleMutation();

  const save = async () => {
    if (!contractId) return;
    
    try {
      await upsertRule({
        contractId: contractId,
        ruleId,
        ruleType: 'DrgConversion',
        priority: 0,
        ruleString: JSON.stringify(rule),
        description: ruleDescription ?? ''
      }).unwrap();
      dispatch(contractApi.util.invalidateTags(['RuleList']));
    } catch (error) {
      console.error('Failed to save rule:', error);
    }
  };

  const ruleDelete = async () => {
    try {
      await deleteRule({ ruleId }).unwrap();
      dispatch(contractApi.util.invalidateTags(['RuleList']));
    } catch (error) {
      console.error('Failed to delete rule:', error);
    }
  };

  useEffect(() => {
    if (ruleString !== '') {
      try {
        const r: { drg: string, description: string, rate: number } = JSON.parse(ruleString);
        setRule(r);
      } catch (error) {
        console.error('Failed to parse rule string:', error);
        setRule({ drg: '', description: '', rate: 0 });
      }
    }
  }, [ruleString, ruleId]);

  return (
    <React.Fragment>
      <Stack direction='row' gap={1}>
        <TextField 
          label='Drg Code' 
          value={rule.drg} 
          sx={{ width: '100px' }}
          onChange={(e) => setRule({ ...rule, drg: e.target.value })}
        />
        <TextField 
          label='Description' 
          value={rule.description} 
          sx={{ width: '300px' }}
          onChange={(e) => setRule({ ...rule, description: e.target.value })}
        />
        <TextField 
          type='number' 
          label='Rate' 
          value={rule.rate} 
          sx={{ width: '100px' }}
          onChange={(e) => setRule({ ...rule, rate: Number(e.target.value) })}
        />
      </Stack>
      <RuleCommands 
        saveCommand={save} 
        deleteCommand={ruleDelete} 
        isNewRule={ruleId === '0'}
      />
    </React.Fragment>
  );
};

export { DrgConversions };